export const Details_1 = [
  {
    id: 1,
    imagePath: require("../../../assets/images/alumni21.png"),
    reference: `In my educational journey, joining  MCA in KCTC  was  my best decision. .This institution helped me a lot to boost my skills in professional world. i would like to thanks all the faculty members that provided me a practical knowledge rather than focusing on theoretical knowledge.`,
    referenceName: "Harwinderjit Singh",
    department: "(MCA Batch 2018)",
  },

  {
    imagePath: require("../../../assets/images/image-10.png"),
    reference:
      "I am very grateful to LKCTC for turning me into the person I am today. Every day, every moment spent at LKCTC taught me something. The Faculty members helped shape my future and were always available to answer our queries. The lecturers did not merely teach us, they are more like guides lighting our path to success and a rewarding career ahead. How I wish I could relive the 4 years I spent here.",
    referenceName: "Kajal Satija",
    id: 6,
  },

  {
    id: 2,
    imagePath: require("../../../assets/images/alumni23.png"),
    reference: `I would like to say that my experience in LKCTC was very memorable and would like to say that my experience in LKCTC was very memorable and unforgettable.Teachers helped me to choose the right path of the success. Teachers support me in each and every situation.I learned the value of the life from Kcl-Imt.I am thankful to all the faculty members of the college for their continuous effort and support. I can proudly say that i studied at LKCTC.`,
    referenceName: "Satwinder",
    department: "(MCA Batch 2015)",
  },
  {
    imagePath: require("../../../assets/images/1538455.jpg"),
    reference:
      "College life sets the tenor for the rest of our professional life. The experiences, the lessons learnt and the personal growth which takes place outside of our comfort zone, goes a long way to ensure we are successful in our pursuits. My time at LKCTC provided all this and more. From a shy, hesitant person, I turned into a confident individual armed with sound professional knowledge of my chosen field. The credit goes to my wonderful teachers at LKCTC who pushed me to explore my potential and do better than yesterday.",
    referenceName: "Paras Dua",
    id: 7,
  },
  {
    imagePath: require("../../../assets/images/image-2.png"),
    reference:
      "I honestly believe that MBA provides a platform for students to start their career on a firm footing. Mt two years at LKCTC gave me immense opportunities to not only increase my knowledge in the subjects that were taught, but also to discover my true potential by participating in various extracurricular programs, academic activities, and inter college fests. I will always remain indebted to my alma mater for my whole life.",
    referenceName: "Samridhi Singla",
    id: 8,
    department: "(MBA)",
  },
  {
    imagePath: require("../../../assets/images/image-3.png"),
    reference:
      "My two years at LKCTC have been excellent and memorable enough to cherish for a lifetime. The years spent over there have been full of learning opportunities that were fun and exciting. The practical exposure that I gained during my studies made me stronger and prepared me to face the tough competition of the corporate world. The success that I have attained today, I attribute it to LKCTC",
    referenceName: "Gurpreet Kaur",
    id: 9,
  },
  {
    id: 22,
    imagePath: require("../../../assets/images/alumnit2.png"),
    reference: `A great place where one experience over all personality development of oneself along with the best academic exposure. Excellent faculty and very good placement.Overall a very good environment for any student with a wide range of degree programs.
`,
    referenceName: "Rajesh Thakur",
    department: "(MCA Batch 2015)",
  },
  {
    imagePath: require("../../../assets/images/image-5.png"),
    reference:
      "Finding the right path to success at the right time is really very important and that's why I had selected LKCTC. The friendly environment, the systematic approach towards imparting education made me a competent individual. The faculties are really very kind and approachable when any need arises. In LKCTC, we are trained for our placements and because of that I was placed in one of the reputed companies for my internship. Today, I am in a good position. Lastly I am really proud to be a part of LKCTC.",
    referenceName: "Twinkle Punj",
    id: 11,
  },
  {
    id: 3,
    imagePath: require("../../../assets/images/alumni22.png"),
    reference: `My 2 years at LKCTC have been excellent and a memory to cherish for a lifetime. The years spent here have been full of learning opportunities that were fun and frolic. LKCTC has always believed in helping and guiding its students and it was no different during the placement season. They always work for the betterment of students so that they could get easily placed in the best companies. I will always be grateful to them for providing me a platform for practical learning and preparing me for the corporate life. All Thanks to LKCTC.`,
    referenceName: "Hemneter",
    department: "(MCA Batch 2017)",
  },
  {
    imagePath: require("../../../assets/images/image-9.png"),
    reference:
      "Do not forget the prestige that comes with studying Engineering. Everyone knows how much effort is required to qualify as an engineer. I never felt boredom because we were part of various events and activities at LKCTC while pursuing engineering. It is a place where one experiences overall personality development along with best academic exposure. So the element of respect comes naturally. Privileged to be a part of this kind of experience with LKCTC and love the way of teaching",
    referenceName: "Prabhjot Singh",
    id: 12,
  },
  {
    imagePath: require("../../../assets/images/image-1.png"),
    reference:
      "My MBA degree played a catalyst role in shaping me into a professional capable enough to makea mark in the competitive professional world. Considering the fact that I was a student of LKCTC, Jalandhar, I was apprehensive at first about my career but believe you me the institute left no stone unturned to shape my future in every possible manner. The success and greater heights that I have attained today, I owe it all to LKCTC",
    referenceName: "Vikram Raja",
    department: "(MBA)",
    id: 16,
  },
  {
    imagePath: require("../../../assets/images/image-7.png"),
    reference: `Spending four years at LKCTC have helped me to gain excellent knowledge and the right attitude towards my career through various opportunities like working on case studies and practical demonstrations. Now, I am working with an IT company "Zapbuild Technologies" as the Team Lead of Process coordinators. I would like to thank the ECE department team who ensured that we, the students, are well organized, maintain attention to develop necessary skills, have commendable client facing skills and are full of confidence by organizing numerous sessions with industry experts, communication experts and also, speakers from different technical fields. Various expert talks by professionals and the training modules organized by LKCTC make the students ready for interviews and inculcate strong competitive skills in students.`,
    referenceName: "Anu Saini",
    id: 13,
  },

  {
    id: 5,
    imagePath: require("../../../assets/images/alumni24.png"),
    reference: `Joining LKCTC for my MCA is the best decision of my life. The institute provided me the best platform and infrastructure to excel in my career interest. The expert faculty made me industry ready, while the placement training helped me enhance my soft skills which made me standout others. Firstly, I would like to thank all the faculty members. I am grateful to LKCTC college for providing me opportunities to explore beyond the blackboard and four-walled classroom. LKCTC where I realized my potential and enhance my development skills. Today I am working as a Technical Manager in an IT Company and working dedicatedly to achieve my goals. This was made possible by LKCTC only. My experience about LKCTC is- They offer wide arena and professional guidance to students to become leaders of tomorrow.`,
    referenceName: "Navjot Kaur",
    department: "(MCA Batch 2015)",
  },
  {
    imagePath: require("../../../assets/images/image-8.png"),
    reference:
      "Lyallpur Khalsa College Technical Campus, Jalandhar has always believed in helping and guiding its students not only in studies but also in Sports and other cultural activities. Being a National player of basketball, State player of Football and University Gold medalist in Debate competitions, I can say that the proper grooming of a personality is done here. Regular classes held at our college help us to enhance our aptitude and technical skills. Our Placement administration officers also guided and encouraged us at each step thereby helping me secure my placement at such a reputed company.",
    referenceName: "Harmanpreet Singh",
    id: 14,
  },
  {
    id: 4,
    imagePath: require("../../../assets/images/alumni25.png"),
    reference: `My 2 years at LKCTC have been excellent and a memory to cherish for a lifetime. The years spent here have been full of learning opportunities that were fun and frolic. LKCTC has always believed in helping and guiding its students and it was no different during the placement season. They always work for the betterment of students so that they could get easily placed in the best companies. I will always be grateful to them for providing me a platform for practical learning and preparing me for the corporate life. All Thanks to LKCTC`,
    referenceName: "Shivani Awasthi",
    department: "(MCA Batch 2015)",
  },
  {
    imagePath: require("../../../assets/images/image-12.png"),
    reference: `For LKCTC, "The world is here, where are you" is not just a slogan but I lived it in reality. LKCTC is a beautiful and historic place where people from different nationalities meet together to share one common goal, EDUCATION. I had the opportunity to meet with the dynamic and distinguished faculties, who are enthusiastic, friendly, patient and highly qualified. With their guidance and constant mentoring I have been able to become a true professional in all the facets of life. Thanks to guidance provided by the Training & Placement Department, without their help I would not have been placed in RAP Projects. I have emerged as a new individual. All Thanks to LKCTC.`,
    referenceName: "Rishav ohri",
    id: 15,
  },
  {
    id: 19,
    imagePath: require("../../../assets/images/alumni19.png"),
    reference: `I would like to say that the 6 years at LKCTC were one of the best periods of my life. At LKCTC it always felt like a family, another home, which helped me in my academic learning. I am thankful to all the faculty members of the College for their continuous efforts and support. Apart from excellent academic experience. I have here a memory, a laugh, a cry, a part of myself. As I open the door, I pause for a moment, and I think to myself. I am proud to be a LKCTCIAN !`,
    referenceName: "Lakhbir Singh Pawar",
    department: "(MCA Batch 2012)",
  },

  {
    id: 17,
    imagePath: require("../../../assets/images/alumni26.png"),
    reference: `The past three years of my life have given me greater visions of my future. I see the LKCTC chapters and myself as an eager child who has just learned to read. I intend to read and probe into all the chapters. The LKCTC offers me more than the great reputation of this fine school, but a large student body with diverse likes and dislikes, and many activities, both academic and non-academic, to participate in. With the help of the LKCTC. I will be successful after college and be able to make a name and place for myself in our society.`,
    referenceName: "Umesh",
    department: "(BCA Batch 2019)",
  },
  {
    id: 18,
    imagePath: require("../../../assets/images/alumni27.png"),
    reference: `I had the most memorable time studying at LKCTC. As we always know "While there is a lot that the real world teaches you, only a good institution can prepare you to handle those experiences" and LKCTC played the precious role in my life. LKCTC broadened my perspectives, not only on IT subjects, but also on personal qualities like being an all-rounder, ethical conduct, and most importantly, being human. I never ever forget the teacher who supports me in each and every situation in my life; I must say they are true blessings in my life. I look back at my days at LKCTC as building blocks to my career. As a successful Software Developer, I am proud to be LKCTC alumnus, last but not the least chase your dream until you catch them.`,
    referenceName: "Muskaan",
    department: "(MCA Batch 2019)",
  },

  {
    id: 20,
    imagePath: require("../../../assets/images/alumni20.png"),
    reference: `It was a such great experience to be a part of LKCTC Jalandhar. Choosing LKCTC for pursuing MCA was one of the best decision I've ever took in my life. The life at LKCTC was really amazing; be in terms of Infrastructure, faculty support or teaching learning process. Teachers are very friendly  and always ready to help. They always want their students to achieve greatness through the exams. The best part about this college is practical teaching process via various Workshops, Seminars and Trainings and Now I am very happy that I am placed as Graphics Designer in Shiksha Infosys and the credit obviously goes to LKCTC. I'm very thankful to my college who gave me a bright future`,
    referenceName: "Navjot",
    department: "(MCA Batch 2019)",
  },
  {
    id: 21,
    imagePath: require("../../../assets/images/alumnit1.png"),
    reference: `My LKCTC days will remain unforgettable. In fact, those were the happiest and most fruitful days in my life and I cherished every moment of them. My experience at LKCTC was just amazing. I got as much love from my teachers as many lessons they gave me and it was with love that they made me work hard for the way to success. Just want to say thanks to the wonderful faculty at LKCTC. Miss those days really...`,
    referenceName: "Kamaljit Singh",
    department: "(MCA Batch 2016)",
  },

  {
    id: 23,
    imagePath: require("../../../assets/images/alumnit3.png"),
    reference: `My educational journey in LKCTC started from 2015. .It was an all in one package, right from shaping my skills coupled with practical knowledge to the Professional ethics leading to my holistic development. LKCTC is profusion of skill development, professional knowledge and industrious faculty. Week after week, my confidence raised watching my mentors teaching and observing their teaching skills has helped me a lot in being a teacher. Currently, I am incumbent faculty of Cambridge international school for girls.`,
    referenceName: "Prinkle Gill",
    department: "(MCA Batch 2015)",
  },
  {
    id: 24,
    imagePath: require("../../../assets/images/alumnit4.png"),
    reference: `Studying at LKCTC and pursuing my Masters degree ( MCA) from such an affiliated college was literally beyond my expectations. Here, I would like you to know that one of the most important things to a successful career ahead, is Confidence. And, if one lacks that very thing, one can never possess courage to execute anything. This college has given me a bucket full of confidence that has helped me to face challenges in every field of life. Apart from the magnificent infrastructure, this college provided me with the much needed practical interface which is usually not given in other colleges. The practicality in every subject assisted a lot to implement the things in industry. Beside, the extra curricular activities held at regular intervals in the college, instilled communication skills in me without which a person cannot deal with the industrial world. Also, the assistance given by our faculty members cannot be described in words as far. In short, thankyou LKCTC for making me what I am today!!`,
    referenceName: "Guneet Saini",
    department: "(MCA Batch 2019)",
  },
  {
    id: 25,
    imagePath: require("../../../assets/images/alumnit5.png"),
    reference: `Finding thethe right path to success at the right time is really very important and crucial part of each one's life. For this, I chose LKCTC as my education platform to pursue my Bachelor and Master Degree. I am highly indebted to the entire faculty of LKCTC as they have always supported, helped and encouraged every time to achieve great heights. This institute gave me a platform to push myself and to understand my potentials that were hidden inside me. Curricular and co- curricular activities that are organized frequently by the management gave me an opportunity to show my talent and this helped to bring up the confidence in me and enhance my skills. This five year journey in KCL-IMT has not only helped me broaden my horizon on knowledge but also helped to discover more about myself. Heartily thanks to all the teachers who were there with me all the time to support and help me to adjust to every situation. Proud to be a LKCTC Alumnus`,
    referenceName: "HarleenKaur",
    department: "(MCA Batch 2019)",
  },
  {
    id: 26,
    imagePath: require("../../../assets/images/alumnit6.png"),
    reference: `Finding the right path to success at the right time is really very important and my right path to success is joining LKCTC. I learned the value of teamwork, focus and persistence - all skills that have proven vital to my career as a Technical Support Engineer and for higher education ( double masters in MAS specialization COMPUTER SECURITY AND FORENSICS). I would like to appreciate the efforts of all the facility members that introduce me with the Tech World. Long story short I am proud to be an LKCTCAIN`,
    referenceName: "Kulwinder Ghai",
    department: "(MCA Batch 2015)",
  },
  // {
  //   id: 21,
  //   imagePath: require("../../../assets/images/alumni27.png"),
  //   reference: `5 years of my life that i spent in kcl-imt were best days of my life. The practical knowledge that i gained here helped me a lot during my interviews and continuesly helping me during my work as well. The best thing is the extra activities where students can enjoy, learn and grow their personality. I still remember singing on the stage, participating in quiz contests, admad show, presentations, gaming and a lot of more activities which helped me to gain a lot of confidence with each participation. I am very thankful to all the professors for guiding me to reach at the position where i am today and very thankful to kcl-imt for giving me such a wonderful memories and a lot of friends who are like family for me.`,
  //   referenceName: "RishavKwatra",
  //   department: "(MCA Batch 2018)",
  // },
  // {
  //   imagePath: require("../../../assets/images/testimonial001.jpg"),
  //   reference:
  //     "My time at lKCE was an experience I will cherish forever. I am very proud to be a student of such college .LKCE has given me a wonderful life with good career and continuous motivation. Life as a LKCE student is unique in its own way. Here Education are perfectly balanced with extra curriculars to achieve overall development of the students.",
  //   // referenceName: "Unknown",
  //   department: "()",
  //   id: 2,
  // },
  // {
  //   imagePath: require("../../../assets/images/testimonial002.jpg"),
  //   reference:
  //     "My 3 years at lyallpur khalsa college of Engineering have been excellent and a memory to cherish for a lifetime. The years spent here have been full of learning opportunities that were full of fun and frolic and sometimes with academic grind that one has to go through. The environment here makes you a better person to face the challenges of the corporate world.",
  //   // referenceName: "Unknown",
  //   id: 3,
  // },
  // {
  //   imagePath: require("../../../assets/images/003_2.jpg"),
  //   reference:
  //     "Think Different, that is one thing that our college urges in and to far extent succeed in teaching to its students which invariably helps to achieve what you need. It nourished me and thus gave me an opportunity to define me.",
  //   // referenceName: "Unknown",
  //   id: 4,
  // },
  // {
  //   imagePath: require("../../../assets/images/testimonial003.jpg"),
  //   reference:
  //     "At the very outset I would like to express my heartiest thanks to the LKCE family. I extend my warm regards to my dept, the Dept. of COMPUTER SCIENCE & ENGINEERING which has immensely helped me succeed.",
  //   // referenceName: "Unknown",
  //   id: 5,
  // },
  // {
  //   imagePath: require("../../../assets/images/testimonial004.jpg"),
  //   reference:
  //     "The college provided me the opportunity to learn and develop through the knowledge given in the lectures and practicals in the laboratories.",
  //   // referenceName: "Unknown",
  //   id: 6,
  // },
  // {
  //   imagePath: require("../../../assets/images/testimonial005.jpg"),
  //   reference:
  //     "I am extremely grateful to the management and staff of LKCE for their tireless efforts to ensure a bright and prosperous future for us.",
  //   // referenceName: "Unknown",
  //   id: 7,
  // },
  // {
  //   imagePath: require("../../../assets/images/testimonial006.jpg"),
  //   reference:
  //     "I take this opportunity to extend my gratitude to LKCE and Department faculty for chiselling my career and sparing their precious time in kindling our talents.",
  //   // referenceName: "Unknown",
  //   id: 8,
  // },
  // {
  //   imagePath: require("../../../assets/images/testimonial007.jpg"),
  //   reference:
  //     "The management and staff of LKCE really helped me in improving my personality, communication, aptitude and technical skills.",
  //   // referenceName: "Unknown",
  //   id: 9,
  // },
  // {
  //   imagePath: require("../../../assets/images/testimonial008.jpg"),
  //   reference:
  //     "The college provided me the opportunity to learn and develop through the knowledge given in the lectures and practicals in the laboratories.",
  //   // referenceName: "Unknown",
  //   id: 10,
  // },
];
export const Details_2 = [
  {
    imagePath1: require("../../../assets/images/Alumni1.jpg"),
    imagePath2: require("../../../assets/images/Alumni2.jpeg"),
    id: 1,
  },
  {
    imagePath1: require("../../../assets/images/Alumni3.jpg"),
    imagePath2: require("../../../assets/images/Alumni4.jpg"),
    id: 2,
  },
  {
    imagePath1: require("../../../assets/images/Alumni5.jpg"),
    imagePath2: require("../../../assets/images/Alumni6.jpg"),
    id: 3,
  },
  {
    imagePath1: require("../../../assets/images/Alumni7.png"),
    imagePath2: require("../../../assets/images/Alumni8.png"),
    id: 4,
  },
  {
    imagePath1: require("../../../assets/images/Alumni9.png"),
    imagePath2: require("../../../assets/images/Alumni10.png"),
    id: 5,
  },
  {
    imagePath1: require("../../../assets/images/Alumni11.png"),
    imagePath2: require("../../../assets/images/Alumni12.png"),
    id: 6,
  },
  {
    imagePath1: require("../../../assets/images/Alumni13.png"),
    imagePath2: require("../../../assets/images/Alumni14.png"),
    id: 7,
  },
  {
    imagePath1: require("../../../assets/images/Alumni15.png"),
    imagePath2: require("../../../assets/images/Alumni16.png"),
    id: 8,
  },
];
